import { BuilderClientStyles } from '../sass/builder-client.scss'; // eslint-disable-line no-unused-vars
// import { EnlargeImg } from '!file-loader!../img/enlarge.png'; // eslint-disable-line no-unused-vars
// import { LoadingBgImg } from '!file-loader!../img/loading-bg.png'; // eslint-disable-line no-unused-vars
// import { LoadingSpinnerImg } from '!file-loader!../img/loading-spinner.gif'; // eslint-disable-line no-unused-vars
// import { LoadingSpinnerImg } from '!file-loader!../img/loading-spinner.svg'; // eslint-disable-line no-unused-vars
import { BuilderClient } from './classes/country-lane/builder-client';

const builderClient = new BuilderClient();
builderClient.dom();
